// export const hostNameAndPort = "http://localhost:80";
export const hostNameAndPort = "https://api.zaklist.com";
